
$(".btn-download").off('click').click(function (a) {
    var authorisation = $(this).data('authorisation');
    var cd = $(this).data('cd');

    $.ajax({
        type: "GET",
        url: laroute.route('public::account::promosets::ajax::download', {
            auth: authorisation,
            cd: cd == undefined ? '' : cd
        })
    }).done(function( msg ) {
        bootbox.alert(msg, function() {});
        $(".btn-download-link").off('click').click(function (a) {
            var link = $(this).data('link');
            var msg = $(this).data('msg');

            bootbox.hideAll();
            location.href = link;
            bootbox.alert(msg);
        });
    });
});

$(".btn-author-and-composer").off('click').click(function (a) {
    var authorisation = $(this).data('authorisation');
    var cd = $(this).data('cd');

    $.ajax({
        type: "GET",
        url: laroute.route('public::account::promosets::ajax::info', {
            auth: authorisation,
            cd: cd == undefined ? '' : cd
        })
    }).done(function( msg ) {
        bootbox.alert(msg, function() {});
    });
});

$(".btn-cerfificates").off('click').click(function (a) {
    var authorisation = $(this).data('authorisation');
    var cd = $(this).data('cd');

    $.ajax({
        type: "GET",
        url: laroute.route('public::account::promosets::ajax::certificates', {
            auth: authorisation,
            cd: cd == undefined ? '' : cd
        })
    }).done(function( msg ) {
        bootbox.alert(msg, function() {});
    });
});

